import React, {useState} from "react";
import {getImage} from "../contentful/data-provider";
import {renderRichText} from "gatsby-source-contentful/rich-text";

import closeIcon from "../img/popup-close.svg";

export default function TeamMember(props) {
    const teamMember = props.content;

    const [opened, setOpened] = useState(false);

    return (
        <div className={`team-member ${opened && 'opened'}`}>
            <div className="team-top" role={'button'} tabIndex={0} onKeyDown={() => setOpened(true)} onClick={() => setOpened(true)}>
                <div className="team-image">
                    <img src={getImage(teamMember.image).url} alt={getImage(teamMember.image).title}/>
                </div>
            </div>
            <div role={'button'} tabIndex={0} className="team-bottom" onKeyDown={() => setOpened(true)} onClick={() => setOpened(true)}>
                <div className="team-text">
                    <h3>{teamMember.name}</h3>
                    <span>{teamMember.position}</span>
                </div>
                <div className="team-link">
                    <div className="more"><i
                        className="fas fa-arrow-right"/></div>
                </div>
            </div>
            <div className={`team-popup`}>
                <div className="fade" role={'button'} tabIndex={0} onKeyDown={() => setOpened(false)} onClick={() => setOpened(false)} aria-label="Close"/>
                <div className="team-popup__inner">
                    <div className="popup-close">
                        <div role={'button'} tabIndex={0} onKeyDown={() => setOpened(false)} onClick={() => setOpened(false)} className="closepopup">X<img
                            src={closeIcon}
                            alt=""/></div>
                    </div>
                    <div className="image">
                        <img src={getImage(teamMember.image).url} alt={getImage(teamMember.image).title}/>
                    </div>
                    <div className="text">
                        <h2>{teamMember.name}</h2>
                        <span>{teamMember.position}</span>
                        {renderRichText(teamMember.body)}
                    </div>
                </div>
            </div>
        </div>
    )
}
